export default {
    message: {
        hello: 'สวัสดี',
        profile: 'โปรไฟล์',
        search: 'ค้นหางานและผู้สมัครที่ตรงใจในประเทศไทย…',
        language: 'ภาษา'
    },
    header: {
        companyDetails: 'รายละเอียดบริษัท',
        subscription: 'การสมัครสมาชิก',
        jobShortlist: 'รายการงานที่ชื่นชอบ',
        bookmarked: 'ที่คั่นไว้',
        settings: 'การตั้งค่า',
        watchTutorial: 'ดูคำแนะนำ',
        updateHiringPreferences: 'อัปเดตความต้องการการจ้างงาน',
        blocked: 'บัญชีที่ถูกบล็อก',
        updatePassword: 'เปลี่ยนรหัสผ่าน',
        logout: 'ออกจากระบบ',
        applications: 'ใบสมัคร',
        updateJobPreferences: 'อัปเดตความต้องการงาน',
        blockedList: 'รายชื่อที่ถูกบล็อก'
    },
    index: {
        tagline: "เชื่อมคุณสู่ประเทศไทย",
        placeholder: "คุณกำลังมองหาอะไร?",
        employmentNetwork: "เครือข่ายการจ้างงาน",
        betaTooltip: "นี่คือเวอร์ชันทดลองสำหรับการลงทะเบียนและทดสอบจริง",
        joinCommunity: "เข้าร่วมชุมชนของเราและรับการอัปเดตฟีเจอร์ก่อนใคร",
        article: "บทความ",
    },
    footer: {
        about: "เกี่ยวกับเรา",
        investors: "นักลงทุน",
        privacy: "นโยบายความเป็นส่วนตัว"
    },
    logout: {
        confirmTitle: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?',
        confirm: 'ออกจากระบบ',
        cancel: 'อยู่ในระบบต่อ'
    },
    homepage: {
        tagline: "เครือข่ายการจ้างงานชั้นนำของประเทศไทย",
        search: "ค้นหางาน\nและ พนักงาน",
        global: "ยึดมั่นในท้องถิ่น เข้าถึงได้ทั่วโลก",
    },
    common: {
        no_results: "ยังไม่มีผลลัพธ์ กรุณาตรวจสอบอีกครั้งเร็ว ๆ นี้!",
        close: 'ปิด',
        save_changes: 'บันทึกการเปลี่ยนแปลง',
        id: 'รหัส',
        block: 'บล็อก',
        report: 'รายงาน',
        verified: 'ยืนยันแล้ว',
        unblock: 'ยกเลิกการบล็อก',
        getStarted: "เริ่มต้นใช้งาน",
        previous: "ก่อนหน้า",
        next: "ถัดไป",
        optional: "(ไม่จำเป็น)",
        show: 'แสดง',
        hide: 'ไม่แสดง',
        termsConfirmation: "ข้าพเจ้ายืนยันว่าข้าพเจ้าได้อ่านและ\nเข้าใจข้อกำหนดในการให้บริการแล้ว",
        cancel: "ยกเลิก",
        yes: "ตกลง!",
        and: "และ",
        get_verified: "ยืนยันตัวตน",
    },
    auth: {
        employers: "นายจ้าง",
        employer_desc: "ลงประกาศงาน ตรวจใบสมัคร\nค้นหาพนักงานและสร้างทีม\nด้วยบุคลากรคุณภาพในไทย",
        employees: "พนักงาน",
        employee_desc: "สำหรับผู้พำนักในประเทศไทย\nหางานท้องถิ่นและต่างประเทศได้ฟรี",
        login: "เข้าสู่ระบบ",
        signup: "สมัครสมาชิก",
        no_account: "ยังไม่มีบัญชี?",
    },
    jobseeker: {
        featured_today: 'แนะนำวันนี้:',
        spotlighted_talent: "ผู้สมัครแนะนำ:",
        show_last: 'แสดงก่อนหน้า',
        show_next: 'แสดงถัดไป',
        account_glance: 'ภาพรวมบัญชี:',
        bookmarked: 'บุ๊คมาร์คแล้ว',
        bookmarked_tooltip: 'จำนวนผู้ว่าจ้างที่ติดตามบัญชีของคุณ',
        profile_views: 'จำนวนผู้ชมโปรไฟล์',
        profile_views_tooltip: 'จำนวนครั้งที่โปรไฟล์ของคุณถูกเข้าชม',
        daily_contact: 'จำนวนการสมัครงานต่อวัน:',
        daily_contact_tooltip: 'จำนวนงานที่คุณสามารถสมัครได้ต่อวัน',
        account_completion: 'ความสมบูรณ์ของบัญชี',
        sit_news: 'ข่าวสารจาก SearchinThailand',
        posted: 'โพสต์เมื่อ',
        source: 'แหล่งที่มา',
        job_picks_for_you: 'งานที่แนะนำสำหรับคุณ:',
        preferred_listing_language: "ภาษาที่ใช้แสดงประกาศ",
        thai: "ภาษาไทย",
        english: "ภาษาอังกฤษ",
        both: "ภาษาไทย และ ภาษาอังกฤษ",
        position: 'ตำแหน่ง',
        location: 'สถานที่',
        subdistrict: 'แขวง/ตำบล',
        posted_by: 'โพสต์โดย',
        salary: 'เงินเดือน',
        based_on_experience: 'ขึ้นอยู่กับประสบการณ์',
        negotiable: 'สามารถต่อรองได้',
        to: 'ถึง',
        Monthly: 'รายเดือน',
        Hourly: 'รายชั่วโมง',
        Weekly: 'รายสัปดาห์',
        Daily: 'รายวัน',
        customized_connection: 'ค้นหาความเชื่อมโยงที่ตรงใจ:',
        quiz_description: 'ทำแบบสอบถามสั้น ๆ เพื่อดูคำแนะนำที่เหมาะสมกับงานหรือผู้สมัคร',
        lets_go: 'เริ่มเลย',
        quiz_confidential: 'คำตอบของคุณจะถูกเก็บเป็นความลับและใช้เพื่อปรับปรุงคำแนะนำให้ตรงความต้องการเท่านั้น',
        notifications: 'การแจ้งเตือน',
        notifications_tooltip: 'ข้อความแจ้งเตือนที่ยังไม่ได้อ่าน',
        publish_account: 'เผยแพร่บัญชี',
        view_my_listing: 'ดูรายการของฉัน',
        toggleVisibility: 'สลับการแสดงผล: สาธารณะหรือส่วนตัว',
        no_news: 'ยังไม่มีข่าวสาร',
        select_all: 'เลือกทั้งหมด',
        deselect_all: 'ยกเลิกทั้งหมด',
        select_visible: 'เลือกที่แสดงอยู่',
        name: 'ชื่อ',
        website: 'เว็บไซต์',
        application_received: 'สมัครเรียบร้อยแล้ว',
        apply_now: 'สมัครงานนี้',
        remote_work: 'งานทางไกล',
        view_cv: 'ดูเรซูเม่',
        download_cv: 'ดาวน์โหลดเรซูเม่',
        applications: 'การสมัครงาน',
        submission_date: 'วันที่สมัคร',
        last_90_days: '90 วันที่ผ่านมา',
        no_applications: 'ยังไม่มีการสมัครงาน',
        blocked_accounts: 'บัญชีที่ถูกบล็อก',
        no_blocked_accounts: 'ไม่มีบัญชีที่ถูกบล็อก',
        pause_job: 'หยุดประกาศงาน',
        edit_job: 'แก้ไขงาน',
        delete_job: 'ลบงาน',
        applications_num: 'จำนวนใบสมัคร',
        new: 'ใหม่',
        job_listing: 'สถานะงาน',
        active: 'เปิดอยู่',
        expired: 'หมดอายุ',
        expires: 'หมดอายุเมื่อ',
        no_published_jobs: 'ยังไม่มีประกาศงานที่เผยแพร่',
        language: "ภาษา",
        availability: "ความพร้อมในการทำงาน",
        apply_by: "สมัครภายใน",
    },
    loginJobSeeker: {
        title: 'เข้าสู่ระบบ',
        email: 'อีเมล',
        password: 'รหัสผ่าน',
        email_placeholder: 'กรอกอีเมลของคุณ',
        password_placeholder: 'กรอกรหัสผ่านของคุณ',
        login_button: 'เข้าสู่ระบบ',
        no_account: 'ยังไม่มีบัญชี?',
        signup_here: 'สมัครสมาชิกที่นี่',
        forget_password: 'ลืมรหัสผ่าน?',
        click_here: 'คลิกที่นี่',
        remember_account: 'จดจำบัญชี',
        login_as: 'เข้าสู่ระบบในชื่อ',
        other_account: 'เข้าสู่ระบบด้วยบัญชีอื่น'
    },
    loginEmployer: {
        title: 'เข้าสู่ระบบผู้ว่าจ้าง',
        email: 'อีเมล',
        password: 'รหัสผ่าน',
        email_placeholder: 'กรอกอีเมลของคุณ',
        password_placeholder: 'กรอกรหัสผ่านของคุณ',
        login_button: 'เข้าสู่ระบบ',
        no_account: 'ยังไม่มีบัญชี?',
        signup_here: 'สมัครสมาชิกที่นี่',
        forget_password: 'ลืมรหัสผ่าน?',
        click_here: 'คลิกที่นี่',
        remember_account: 'จดจำบัญชี',
        login_as: 'เข้าสู่ระบบในชื่อ',
        other_account: 'เข้าสู่ระบบด้วยบัญชีอื่น'
    },
    jobSeekerProfile: {
        hi: 'สวัสดี',
        verified: 'ยืนยันแล้ว',
        founding_supporter: 'ผู้สนับสนุนก่อตั้ง',
        addSocial: 'เพิ่มโซเชียลมีเดีย',
        memberId: 'รหัสสมาชิก',
        since: 'ตั้งแต่',
        profilePreferences: 'การตั้งค่าโปรไฟล์',
        searchJobs: 'ค้นหางาน',
        notifications: 'การแจ้งเตือน',
        accountPreferences: {
            email: 'อีเมล:',
            first_name: 'ชื่อจริง:',
            last_name: 'นามสกุล:',
            about_me: 'เกี่ยวกับฉัน:',
            about_me_placeholder: 'กรอกข้อมูลของคุณ',
            upload_cv: 'อัปโหลดประวัติส่วนตัว:',
            browse_file: 'เลือกไฟล์',
            allowed_formats: 'อนุญาตเฉพาะไฟล์ .pdf, .doc, .docx, Jpg, Jpeg, Webp และ PNG',
            download_cv: 'ดาวน์โหลดเรซูเม่',
            education: 'ระดับการศึกษา:',
            select_education: 'เลือกระดับการศึกษา',
            gender: 'เพศ:',
            select_gender: 'เลือกเพศ',
            birthdate: 'วันเกิด:',
            enter_birthdate: 'กรอกวันเกิด',
            languages: 'ภาษาที่พูดได้:',
            select_languages: 'เพิ่มได้สูงสุด 3 ภาษา',
            contact_by: 'ให้นายจ้างติดต่อคุณผ่าน:',
            phone: 'เบอร์โทร',
            line_id: 'ไลน์ไอดี',
            search_job_position: "ค้นหาชื่อตำแหน่งงานหรือหน้าที่",
            search_job_position_placeholder: "เริ่มพิมพ์เพื่อตำแหน่งที่ต้องการ",
            industry_of_interest: "อุตสาหกรรมหลัก",
            select_industry: "เลือกอุตสาหกรรม",
            area_of_expertise: 'ความเชี่ยวชาญ:',
            select_specialization: 'เลือกความเชี่ยวชาญ',
            select_industry_first: 'กรุณาเลือกอุตสาหกรรมก่อน',
            preferred_job_roles: 'เลือกตำแหน่งงาน (สามารถเลือกได้หลายตำแหน่ง)',
            position_types: 'ประเภทตำแหน่งงาน',
            selectIndustryFirst: "กรุณาเลือกอุตสาหกรรมก่อน",
            preferredRoles: "บทบาทงานที่ต้องการ",
            province: "จังหวัด",
            select_province: "เลือกจังหวัด",
            district: "เขต/อำเภอ",
            select_district: "เลือกเขต/อำเภอ",
            sub_district: "แขวง/ตำบล",
            select_sub_district: "เลือกแขวง/ตำบล",
            zip_code: "รหัสไปรษณีย์",
            desired_employment_type: "ประเภทการจ้างงาน:",
            employment_type: "ประเภทงานที่ต้องการ:",
            selectEmploymentType: "เลือกประเภทการจ้างงาน",
            availability: "วันเวลาที่สามารถเริ่มงาน",
            availability_for_work: "ความพร้อมในการทำงาน:",
            select_availability: "เลือกวันเวลาที่สามารถเริ่มงาน",
            days_available: 'เลือกวันที่ว่าง',
            select_days_available: "เลือกวันที่สามารถทำงานได้",
            desired_compensation: "ค่าตอบแทน:",
            compensation: "ค่าตอบแทนที่ต้องการ",
            compensationMobile: "ค่าตอบแทน",
            salary: 'ค่าตอบแทนที่ต้องการ:',
            amount: 'จำนวน:',
            to: "ถึง",
            currency: "฿",
            update: 'อัปเดต',
        },
        job_category: "หมวดหมู่งาน",
        location: "สถานที่",
        subdistrict: "แขวง/ตำบล",
        zipcode: "รหัสไปรษณีย์",
        languages: "ภาษา",
        availability: "ความพร้อมในการทำงาน",
        apply_by: "สมัครภายใน",
        salary_requirements: "ความต้องการเงินเดือน",
        member_id: "รหัสสมาชิก",
        joined: "เข้าร่วมเมื่อ",
        about_me: "เกี่ยวกับฉัน",
        position_details: 'รายละเอียดตำแหน่งงาน',
        edit_profile: 'แก้ไขโปรไฟล์',
        last_login: 'เข้าสู่ระบบล่าสุด',
    },
    jobSeekerSearch: {
        work_location: "สถานที่ทำงาน",
        province: "จังหวัด",
        any: "ทั้งหมด",
        local: "ในพื้นที่",
        remote: "ทางไกล",
        placeholder: "ค้นหางานใกล้บ้านหรืองานออนไลน์...",
        job_filter_options: "ตัวกรองการค้นหา",
        industry: "อุตสาหกรรม",
        select_industry: "เลือกอุตสาหกรรม",
        specialization: "ความเชี่ยวชาญเฉพาะ",
        optional: "(ไม่บังคับ)",
        position: "ตำแหน่งงาน",
        position_types: "ประเภทตำแหน่ง",
        select_specialization_first: "เลือกความเชี่ยวชาญเฉพาะก่อน",
        salary_range: "ช่วงเงินเดือน",
        to: "ถึง",
        language: "ภาษา",
        availability: "ความพร้อมในการทำงาน",
        simple_search: "ค้นหาแบบง่าย",
        clear_fields: "ล้างข้อมูล",
        search: "ค้นหา",
        posted_by: "โพสต์โดย",
        location: "สถานที่",
        remote_work: "งานทางไกล",
        apply_by: "สมัครภายใน",
        salary: "เงินเดือน",
        based_on_experience: "ขึ้นอยู่กับประสบการณ์",
        negotiable: "สามารถต่อรองได้",
        position_details: "รายละเอียดตำแหน่ง",
        no_results: "ยังไม่มีผลลัพธ์ ลองใหม่อีกครั้งเร็ว ๆ นี้!"
    },
    jobSeekerMessages: {
        block_user: "บล็อกผู้ใช้",
        delete_notification: "ลบการแจ้งเตือน",
        company: "บริษัท",
        view_detail: "ดูรายละเอียด",
        time: "เวลา",
        contacted_by: "ติดต่อโดย",
        date: "วันที่",
        view_details: "ดูรายละเอียด",
        no_new_notifications: "ไม่มีข้อความแจ้งเตือนใหม่",
        contacted: 'พยายามติดต่อคุณ!',
    },
    jobseekerQuiz: {
        title: 'ปลดล็อกศักยภาพในการหางานของคุณ',
        description: 'ทำแบบสอบถามสั้น ๆ เพื่อค้นหาโอกาสในการทำงานที่ตรงกับทักษะและคุณสมบัติของคุณ',
        lets_go: 'เริ่มเลย',
        confidentiality: 'คำตอบของคุณจะถูกเก็บเป็นความลับและใช้เพื่อปรับปรุงคำแนะนำให้ตรงความต้องการเท่านั้น',
        retake_quiz: 'ทำแบบสอบถามอีกครั้ง',
        submit_answers: 'ส่งคำตอบ',
        next_question: 'ถัดไป',
        previous_question: 'ย้อนกลับ',
        finish: 'เสร็จสิ้น',
        loading: 'กำลังโหลดแบบสอบถาม...',
        no_questions: 'ไม่มีคำถามในแบบสอบถามขณะนี้',
        title_job: 'ความต้องการในอาชีพ',
        question_progress: 'คำถาม {current} จาก {total}',
        thank_you: 'ขอบคุณสำหรับคำตอบของคุณ',
        completed: 'คุณได้ทำแบบสอบถามเสร็จเรียบร้อยแล้ว',
        back: 'ย้อนกลับ',
        next: 'ถัดไป',
    },
    quiz: {
        complete: "ทำแบบทดสอบ",
        receive: "เพื่อรับคำแนะนำงานที่เหมาะกับคุณ"
    },
    employer: {
        contact_name: 'ชื่อผู้ติดต่อ',
        company_website: 'เว็บไซต์บริษัท',
        location: 'สถานที่',
        subdistrict: 'แขวง/ตำบล',
        phone_registration: 'เบอร์โทรที่ลงทะเบียน',
        about: 'เกี่ยวกับ',
        joined_on: 'เข้าร่วมเมื่อ:',
        job_dashboard: 'แดชบอร์ดงาน',
        employee_search: 'ค้นหาผู้สมัคร',
        applications: 'การสมัครงาน',
        new: 'ใหม่',
        create_new_job: 'สร้างงานใหม่',
        publish: 'เผยแพร่',
        private: 'ส่วนตัว',
        position_type: 'ประเภทตำแหน่ง',
        preferred_listing_language: 'ภาษาที่ใช้แสดงประกาศ',
        job_type: 'ประเภทงาน',
        language: 'ภาษา',
        remote_work: 'งานทางไกล',
        compensation: 'ค่าตอบแทน',
        based_on_experience: 'ขึ้นอยู่กับประสบการณ์',
        negotiable: 'สามารถต่อรองได้',
        expires: 'ประกาศหมดอายุ',
        block_user: 'บล็อกผู้ใช้',
        delete_application: 'ลบการสมัครงาน',
        user_name: 'ชื่อผู้ใช้',
        added_to_shortlist: 'เพิ่มในรายการโปรดแล้ว',
        add_to_shortlist: 'เพิ่มผู้สมัครในรายการโปรด',
        submitted_application: 'ส่งใบสมัครแล้ว',
        application_time: 'เวลาสมัคร',
        job_title: 'ชื่องาน',
        application_date: 'วันที่สมัคร',
        no_new_applications: 'ยังไม่มีการสมัครใหม่',
        verified: "ยืนยันแล้ว",
    },
    employerProfile: {
        spotlighted_talent: "ผู้สมัครแนะนำ:",
        job_dashboard: "แดชบอร์ดงาน",
        employee_search: "ค้นหาผู้สมัคร",
        applications: "ใบสมัคร",
        new_applications: "ใบสมัครใหม่",
        founding_supporter: 'ผู้สนับสนุนก่อตั้ง',
        job_title: "ชื่อตำแหน่งงาน",
        applicant_name: "ชื่อผู้สมัคร",
        application_date: "วันที่สมัคร",
        application_time: "เวลาที่สมัคร",
        add_to_shortlist: "เพิ่มผู้สมัครในรายการโปรด",
        added_to_shortlist: "เพิ่มในรายการโปรดแล้ว",
        block_user: "บล็อกผู้ใช้",
        delete_application: "ลบใบสมัคร",
        no_applications: "ไม่มีใบสมัครใหม่",
        email: "อีเมล",
        first_name: "ชื่อ",
        last_name: "นามสกุล",
        company_name: "ชื่อบริษัท",
        company_industry: "อุตสาหกรรมของบริษัท",
        company_address: "ที่อยู่บริษัท",
        company_website: "เว็บไซต์บริษัท",
        country: "ประเทศ",
        province: "จังหวัด / รัฐ",
        district: "เขต / อำเภอ",
        sub_district: "แขวง/ตำบล",
        zipcode: "รหัสไปรษณีย์",
        phone_registration: 'เบอร์โทรที่ลงทะเบียน',
        introduction: "แนะนำบริษัท",
        introduction_count: "ใช้ไป",
        save_changes: "บันทึกการเปลี่ยนแปลง",
        select_industry: "เลือกอุตสาหกรรม",
        select_country: "เลือกประเทศ",
        please_select_country: "กรุณาเลือกประเทศ",
        profile_since: "เป็นสมาชิกตั้งแต่",
        last_login: "เข้าสู่ระบบล่าสุด",
        member_id: "รหัสสมาชิก",
        edit_profile: "แก้ไขโปรไฟล์",
        subscription_plan: "แผนสมาชิก",
        current_plan: "แผนปัจจุบันของคุณ:",
        plan_expires: "แผนหมดอายุ:",
        verified_account: "บัญชีที่ยืนยันแล้ว",
        daily_applications: "ใบสมัครต่อวัน",
        smart_notifications: "การแจ้งเตือนอัจฉริยะ",
        early_access: "สิทธิ์เข้าถึงก่อน",
        supporter_badge: "ตราสัญลักษณ์ผู้สนับสนุน",
        free_plan: "คุณใช้แผนฟรี",
        upgrade_cta: "อัปเกรดเพื่อเข้าถึงคุณสมบัติพิเศษและเข้าถึงเร็วขึ้น",
        upgrade_now: "ดูตัวเลือกการอัปเกรด",
        featured_today: 'แนะนำวันนี้:',
        show_last: 'แสดงก่อนหน้า',
        show_next: 'แสดงถัดไป',
        account_glance: 'ภาพรวมบัญชี:',
        active_projects: 'โปรเจกต์ที่เปิดอยู่',
        bookmarked: 'ที่คั่นแล้ว',
        account_views: 'จำนวนการดูบัญชี',
        daily_contact: 'จำนวนการติดต่อรายวัน:',
        view_company_listing: 'ดูรายการบริษัท',
        news_header: 'ข่าวสารจาก SearchinThailand',
        news_posted: 'โพสต์เมื่อ',
        news_source: 'แหล่งข่าว',
        news_empty: 'ไม่มีข้อความใหม่',
        start_matching_title: 'เริ่มต้นจับคู่ผู้สมัครที่เหมาะสม',
        start_matching_description: 'ทำแบบสอบถามนี้เพื่อรับคำแนะนำผู้สมัครที่เหมาะกับความต้องการของคุณ',
        lets_go: 'ไปต่อ',
        quiz_confidential: 'ข้อมูลของคุณจะถูกเก็บเป็นความลับและใช้เพื่อเพิ่มคุณภาพของคำแนะนำเท่านั้น',
        recommended_candidates: 'ผู้สมัครที่แนะนำ:',
        no_recommendations: 'ยังไม่มีผู้สมัครที่แนะนำ',
        name: 'ชื่อ',
        location: 'สถานที่',
        subdistrict: 'ตำบล',
        specialization: 'ความเชี่ยวชาญ',
        skills: 'ทักษะ',
        job_shortlist: 'รายการโปรด',
        no_favorites: 'ยังไม่มีรายการโปรด',
        remove: 'ลบ',
        job_category: 'หมวดหมู่งาน',
        availability: 'ช่วงเวลาทำงาน',
        compensation: 'ค่าตอบแทน',
        negotiable: 'ต่อรองได้',
        close: 'ปิด',
        bookmark_empty: 'ยังไม่มีรายการบุ๊กมาร์กของคุณ',
        blocked: 'บัญชีที่ถูกบล็อก',
        unblock: 'ปลดบล็อก',
        no_blocked_accounts: 'ไม่มีบัญชีที่ถูกบล็อก',
        update_password: 'อัปเดตรหัสผ่าน',
        current_password: 'รหัสผ่านปัจจุบัน',
        new_password: 'รหัสผ่านใหม่',
        confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
        password_matched: 'รหัสผ่านตรงกัน',
        incorrect_password: 'รหัสผ่านปัจจุบันไม่ถูกต้อง',
        password_different: 'รหัสผ่านใหม่ไม่เหมือนเดิม',
        password_same: 'รหัสผ่านใหม่ต้องไม่เหมือนกับรหัสผ่านเดิม',
        passwords_match: 'รหัสผ่านตรงกัน',
        passwords_not_match: 'รหัสผ่านใหม่และยืนยันไม่ตรงกัน',
        send_message: "ส่งข้อความ",
        no_messages: "ยังไม่มีข้อความ",
        from: "จาก",
        to: "ถึง",
        enter_message: "พิมพ์ข้อความของคุณ",
        languages: "ภาษา",
        salary_requirements: "เงินเดือนที่ต้องการ",
        since: "เป็นสมาชิกตั้งแต่",
        block: "บล็อก",
        report: "รายงาน",
        bookmark: "เพิ่มในรายการโปรด",
        verified: "ยืนยันแล้ว",
        about: "เกี่ยวกับ",
        view_contact: "ดูข้อมูลติดต่อ",
        view_cv: "ดูเรซูเม่",
        call: "โทร",
        contact_name: "ชื่อผู้ติดต่อ",
        edit_intro: "แก้ไขข้อมูลบริษัท",
        enter_company_info: "กรอกข้อมูลบริษัท",
        joined: "เข้าร่วมเมื่อ",
        socialMedia: {
            update: "แก้ไขโซเชียลมีเดีย",
            name: "ชื่อโซเชียลมีเดีย",
            url: "ลิงก์โซเชียลมีเดีย",
            goToLink: "ไปยังลิงก์",
            save: "บันทึก",
            remove: "ลบ"
        },
        banner: {
            title: 'แบนเนอร์',
            upload: 'อัปโหลดไฟล์'
        },
    },
    employerQuiz: {
        title: "ความต้องการของนายจ้าง",
        question: "คำถามที่",
        of: "จากทั้งหมด",
        complete: "แบบสอบถามเสร็จสมบูรณ์!",
        saved: "ระบบได้บันทึกคำตอบของคุณแล้ว",
        back: "ย้อนกลับ",
        next: "ถัดไป",
        close: "ปิด"
    },
    employerPostJob: {
        create_new_job: "สร้างงานใหม่",
        updatePost: "แก้ไขประกาศงาน",
        jobTitle: "ชื่อตำแหน่งงาน",
        jobDescription: "รายละเอียดงาน",
        searchJobPosition: "ค้นหาตำแหน่งงาน",
        jobCategory: "หมวดหมู่งาน",
        positionType: "ประเภทตำแหน่ง",
        selectPosition: "เลือกตำแหน่ง",
        compensation: "ค่าตอบแทน",
        fixedAmount: "จำนวนคงที่",
        paymentRange: "ช่วงค่าตอบแทน",
        experience: "ตามประสบการณ์",
        negotiable: "สามารถต่อรองได้",
        languagesSpoken: "ภาษาที่ใช้",
        employmentType: "ประเภทงาน",
        specifyLocation: "ระบุสถานที่",
        remoteWork: "ทำงานจากที่บ้าน",
        flexible: "ยืดหยุ่น",
        province: "จังหวัด",
        district: "อำเภอ",
        subDistrict: "ตำบล",
        zipCode: "รหัสไปรษณีย์",
        jobExpiration: "วันหมดอายุของประกาศงาน",
        preview: "ดูตัวอย่าง",
        update: "อัปเดต",
        cancel: "ยกเลิกงาน",
        visibilityNote: "คุณต้องการให้ประกาศงานของคุณแสดงได้นานแค่ไหน (สูงสุด 30 วัน)",
        job_title: "ชื่อตำแหน่งงาน",
        job_title_placeholder: "กรอกชื่อตำแหน่งงานที่ต้องการประกาศ",
        job_description: "รายละเอียดงาน",
        job_description_placeholder: "อธิบายหน้าที่ ความรับผิดชอบ และคุณสมบัติที่ต้องการ",
        search_position: "ค้นหาตำแหน่งงาน",
        search_position_placeholder: "เริ่มพิมพ์เพื่อตำแหน่งงานที่ต้องการ",
        job_category: "หมวดหมู่งาน",
        job_category_placeholder: "ค้นหาหมวดหมู่งาน",
        position_type: "ประเภทตำแหน่งงาน",
        position_type_placeholder: "เลือกประเภทตำแหน่งงาน",
        select_position: "เลือกตำแหน่ง",
        select_position_placeholder: "เลือกตำแหน่งงานที่คุณต้องการ",
        validate_title: 'กรุณากรอกชื่อตำแหน่งงาน',
        validate_category: 'กรุณาเลือกหมวดหมู่งาน',
        validate_position_types: 'กรุณาเลือกประเภทตำแหน่งงาน',
        validate_sub_position_types: 'กรุณาเลือกตำแหน่งงานย่อย',
        validate_province: 'กรุณาเลือกจังหวัด',
        validate_amphure: 'กรุณาเลือกอำเภอ',
        validate_district: 'กรุณาเลือกตำบล',
        validate_zip: 'กรุณากรอกรหัสไปรษณีย์',
        validate_expire_date: 'กรุณากำหนดวันหมดอายุ',
        validate_expire_time: 'กรุณากำหนดเวลาหมดอายุ',
        validate_payment_amount: 'กรุณากรอกจำนวนค่าตอบแทน',
        validate_payment_range: 'กรุณากรอกช่วงค่าตอบแทน',
        validate_payment_type: 'กรุณาเลือกประเภทค่าตอบแทน',
        validate_language: 'กรุณาระบุภาษาที่พูดได้',
        validate_availability: 'กรุณาเลือกช่วงเวลาที่สามารถทำงานได้',
    },
    employerPost: {
        compensation: {
            title: "ค่าตอบแทน",
            fixed: "จำนวนคงที่",
            range: "ช่วงเงินเดือน",
            experience: "ขึ้นอยู่กับประสบการณ์",
            negotiable: "ต่อรองได้",
            enterFixed: "กรอกจำนวนเงินคงที่",
            min: "ต่ำสุด",
            max: "สูงสุด",
            to: "ถึง",
            per: "ต่อ",
            hour: "ชั่วโมง",
            day: "วัน",
            week: "สัปดาห์",
            month: "เดือน",
            job: "งาน",
        },
        language: {
            label: "ภาษาที่พูดได้",
            placeholder: "กรอกภาษาที่ต้องการ (เช่น ภาษาอังกฤษ ภาษาไทย ภาษาจีน)"
        },
        employmentType: {
            label: "ประเภทงาน",
            placeholder: "เลือกประเภทของงานสำหรับตำแหน่งนี้"
        },
        showAddress: {
            label: "แสดงที่อยู่ของสถานที่ทำงาน"
        },
        location: {
            specify: "ระบุสถานที่",
            remote: "ทำงานจากระยะไกล",
            flexible: "ยืดหยุ่น",
            info: "สามารถทำงานได้ทั้งในสถานที่และระยะไกล",
            province: "จังหวัด",
            district: "อำเภอ",
            subDistrict: "ตำบล",
            zip: 'รหัสไปรษณีย์',
            selectProvince: "เลือกจังหวัด",
            selectDistrict: "เลือกอำเภอ",
            selectSubDistrict: "เลือกตำบล",
        },
        expiration: {
            label: "วันที่หมดอายุของประกาศงาน",
            placeholder: "ว/ด/ป ชม:นาที",
            note: "คุณต้องการให้โพสต์งานนี้แสดงได้นานแค่ไหน? (สูงสุด 30 วัน)"
        },
        footer: {
            preview: "ดำเนินการดูตัวอย่าง",
            update: "อัปเดต",
            cancel: "ยกเลิกงาน"
        }
    },
    account: {
        update_password: 'อัปเดตรหัสผ่าน',
        current_password: 'รหัสผ่านปัจจุบัน',
        new_password: 'รหัสผ่านใหม่',
        confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
        password_matched: 'รหัสผ่านตรงกัน',
        incorrect_current_password: 'รหัสผ่านปัจจุบันไม่ถูกต้อง',
        password_is_different: 'รหัสผ่านใหม่ไม่ซ้ำกับรหัสเดิม',
        password_same_as_old: 'รหัสผ่านใหม่ต้องไม่เหมือนกับรหัสเดิม',
        passwords_match: 'รหัสผ่านตรงกัน',
        passwords_do_not_match: 'รหัสผ่านใหม่และการยืนยันไม่ตรงกัน',
        upgrade_account: 'อัปเกรดบัญชี',
        secure_payment_note: '🔒 ชำระเงินครั้งเดียวอย่างปลอดภัย ไม่มีการต่ออายุอัตโนมัติ',
        no_subscription_required: 'ไม่ต้องสมัครสมาชิกรายเดือน!',
        subscription_plan: 'แผนการสมัครสมาชิก',
        current_plan: 'คุณอยู่ในแผน:',
        plan_expires: 'แผนหมดอายุ:',
        verified_account: 'บัญตียืนยันตัวตน',
        verified_description: 'บัญชีของคุณได้รับการยืนยันและจะเห็นได้ชัดเจนขึ้นต่อผู้ว่าจ้าง',
        daily_applications: 'จำนวนการสมัครงานต่อวัน',
        jobs_per_day: 'งานต่อวัน',
        smart_notifications: 'การแจ้งเตือนอัจฉริยะ',
        smart_notifications_desc: 'รับการแจ้งเตือนเมื่อมีงานที่ตรงกับทักษะของคุณ',
        early_access: 'สิทธิ์เข้าใช้งานก่อน',
        early_access_desc: 'คุณจะได้รับแจ้งเมื่อโหมดฟรีแลนซ์ การโปรโมตโปรไฟล์ และฟีเจอร์ใหม่ ๆ พร้อมใช้งาน',
        founding_supporter: 'เหรียญผู้สนับสนุนแรกเริ่ม',
        founding_supporter_desc: 'ขอบคุณที่สนับสนุนเราในช่วงเริ่มต้น!',
        on_free_plan: 'คุณอยู่ในแผนฟรี',
        apply_limit: 'คุณสามารถสมัครได้',
        upgrade_benefits: 'อัปเกรดเพื่อขยายการเข้าถึง รวดเร็วขึ้น และเข้าถึงฟีเจอร์พิเศษ',
        see_upgrade_options: 'ดูตัวเลือกการอัปเกรด',
        password_rules: [
            'ต้องมีอย่างน้อย 12 ตัวอักษร',
            'สามารถใช้ตัวอักษร ตัวเลข สัญลักษณ์ และช่องว่างได้'
        ],
        password_min_length: 'รหัสผ่านต้องมีอย่างน้อย 12 ตัวอักษร',
        new_password_required: 'รหัสผ่านใหม่ต้องไม่เว้นว่าง',
        password_updated: 'อัปเดตรหัสผ่านเรียบร้อยแล้ว',
        password_update_error: 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',
    },
    socialMedia: {
        title: 'อัปเดต - โซเชียลมีเดีย',
        name: 'ชื่อโซเชียลมีเดีย',
        url: 'ลิงก์โซเชียลมีเดีย',
        visit_link: 'ไปที่ลิงก์',
        addTitle: 'เพิ่มโซเชียลมีเดีย',
        selectPlaceholder: 'เลือกโซเชียลมีเดีย',
        urlPlaceholder: 'ลิงก์โซเชียลมีเดีย',
        validationRequired: 'กรุณากรอกทุกช่อง!',
        validationInvalid: 'URL ไม่ถูกต้องสำหรับโซเชียลมีเดียที่เลือก!',
        successTitle: 'สำเร็จ!',
        successMessage: 'เพิ่มโซเชียลมีเดียเรียบร้อยแล้ว',
    },
    general: {
        no_results_check_accounts: 'ยังไม่มีผลลัพธ์ ลองดูบัญชีเหล่านี้แทน'
    },
    upgradeEmployer: {
        title: "ส่วนลดพิเศษปีแรก",
        heading: "ยกระดับกลยุทธ์การจ้างงานของคุณ",
        description: "เพลิดเพลินกับราคาส่วนลดพิเศษในปีแรกของเรา – คุ้มค่ามากขึ้นและเพิ่มประสิทธิภาพในการสรรหาในประเทศไทย",
        basicPlan: "แพ็กเกจทั่วไป",
        enterprisePlan: "แพ็กเกจองค์กร",
        popular: "ยอดนิยมที่สุด",
        discountedFrom: "ลดราคาจาก",
        noSubscription: "ไม่ต้องสมัครสมาชิก!",
        close: "ปิด"
    },
    subscriptionEmployer: {
        title: "การสมัครสมาชิก:",
        yourId: "รหัสของคุณ:",
        memberSince: "เป็นสมาชิกตั้งแต่:",
        plan: "แผนการสมัครสมาชิก:",
        expiration: "วันหมดอายุ:",
        upgrade: "อัปเกรดแผนของคุณ",
        close: "ปิด"
    },
    jobDetail: {
        category: 'หมวดหมู่งาน',
        location: 'สถานที่ทำงาน',
        remote: 'งานระยะไกล',
        availability: 'เวลาทำงาน',
        language: 'ภาษา',
        compensation: 'ค่าตอบแทน',
        experienceBased: 'ตามประสบการณ์',
        negotiable: 'ต่อรองได้',
        positionDetails: 'รายละเอียดตำแหน่งงาน:',
        postedBy: 'โพสต์โดย:',
        name: 'ชื่อ',
        website: 'เว็บไซต์',
        viewDetail: 'ดูรายละเอียด',
        viewCompany: 'ดูบริษัท',
    },
    postJob: {
        publish: 'เผยแพร่ประกาศงาน',
        update: 'อัปเดตงาน',
        backToEdit: 'กลับไปแก้ไข'
    },
    employerSignup: {
        locationVerification: "ยืนยันตำแหน่งที่ตั้ง",
        alreadyHaveAccount: "มีบัญชีอยู่แล้วหรือไม่?",
        login: "เข้าสู่ระบบ",
        createPassword: "สร้างรหัสผ่าน",
        createPasswordNote: "กรุณาสร้างรหัสผ่านสำหรับบัญชีของคุณ",
        companyInfo: "ข้อมูลบริษัท",
        tellUsCompany: "กรุณาให้ข้อมูลเกี่ยวกับบริษัทของคุณ",
        phoneVerification: "ยืนยันหมายเลขโทรศัพท์",
        phoneVerificationNote: "กรุณายืนยันหมายเลขโทรศัพท์ของคุณ",
        choosePlan: "เลือกแผนที่เหมาะสมสำหรับธุรกิจของคุณ",
        discoverTalent: "ค้นหาผู้สมัครที่ใช่ในประเทศไทย",
        streamlineTools: "ด้วยเครื่องมือที่ช่วยให้การจ้างงานง่ายขึ้น",
        companyAddress: "ที่อยู่บริษัท",
        verifyIdentity: "ยืนยันตัวตนของคุณ",
        completeRegistration: "กรอกข้อมูลให้ครบเพื่อสมัครสมาชิก",
        secureExperience: "เพื่อให้ประสบการณ์การใช้งานปลอดภัยยิ่งขึ้น",
        notLocated: "คุณไม่ได้อยู่ในประเทศไทย",
        connectTitle: "เชื่อมต่อกับผู้มีความสามารถในประเทศไทย",
        connectDesc: "เข้าร่วมเครือข่ายของเราเพื่อเข้าถึงผู้เชี่ยวชาญในหลากหลายอุตสาหกรรมในประเทศไทยที่เหมาะกับความต้องการของคุณ",
        connectTalentTitle: "เชื่อมต่อกับผู้สมัครที่มีศักยภาพ",
        connectTalentDesc: "ค้นหาและติดต่อผู้สมัครที่ตรงตามความต้องการของคุณ",
        postJobsTitle: "ลงประกาศงานได้อย่างง่ายดาย",
        postJobsDesc: "สร้างประกาศงานอย่างรวดเร็วและดึงดูดผู้สมัครที่เหมาะสม",
        personalizedTitle: "ระบบจับคู่งานอัจฉริยะ",
        personalizedDesc: "ประหยัดเวลาด้วยการเน้นไปที่ผู้สมัครที่ตรงกับความต้องการของคุณ โดยระบบแนะนำของเรา",
        streamlineTitle: "จัดการการจ้างงานอย่างมีประสิทธิภาพ",
        streamlineDesc: "จัดการและจัดอันดับผู้สมัครงาน โปรดบุ๊คมาร์คและมอบหมายผู้สมัครงานให้ตรงกับตำแหน่งที่ต้องการเพื่อความรวดเร็ว",
        firstName: "ชื่อจริง",
        firstNamePlaceholder: "กรอกชื่อจริง",
        lastName: "นามสกุล",
        lastNamePlaceholder: "กรอกนามสกุล",
        companyName: "ชื่อบริษัท",
        companyNamePlaceholder: "กรอกชื่อบริษัท",
        companyNameExists: "ชื่อบริษัทนี้ถูกใช้งานแล้ว…",
        email: "อีเมล",
        emailPlaceholder: "กรอกอีเมลของคุณ",
        confirmEmail: "ยืนยันอีเมล",
        agree: "ฉันยอมรับ",
        termsOfService: "ข้อกำหนดการให้บริการ",
        sendVerification: "ส่งรหัสยืนยันทางอีเมล",
        verificationCode: "กรอกรหัสยืนยัน",
        codePlaceholder: "รหัสยืนยัน",
        password: "รหัสผ่าน",
        passwordPlaceholder: "กรอกรหัสผ่าน",
        confirmPassword: "ยืนยันรหัสผ่าน",
        confirmPasswordPlaceholder: "ยืนยันรหัสผ่านอีกครั้ง",
        industry: "อุตสาหกรรมของบริษัท",
        selectIndustry: "เลือกอุตสาหกรรมของบริษัท",
        size: "ขนาดของบริษัท",
        selectSize: "เลือกขนาดของบริษัท",
        website: "เว็บไซต์ของบริษัท",
        websitePlaceholder: "ป้อนเว็บไซต์ (ถ้ามี)",
        address: "ที่อยู่บริษัท",
        addressPlaceholder: "ป้อนที่อยู่ของบริษัท",
        country: "ประเทศ",
        selectCountry: "เลือกประเทศ",
        city: "เขต / เมือง",
        selectDistrict: "เลือกเขต",
        province: "จังหวัด / รัฐ",
        selectProvince: "เลือกจังหวัด",
        zip: "รหัสไปรษณีย์",
        selectCountryFirst: "กรุณาเลือกประเทศก่อน",
        phoneLabel: "เบอร์โทรศัพท์",
        sendVerificationPhone: "ส่งรหัสยืนยัน",
        enterVerificationCode: "กรอกรหัสยืนยัน",
        verificationCodePlaceholder: "รหัสยืนยัน",
        create: "สร้างบัญชี",
        popular: "ยอดนิยม",
        noSubscription: "ไม่จำเป็นต้องสมัครสมาชิก!",
        purchaseOption: "สามารถซื้อประกาศงานเพิ่มเติมได้",
        subscribe: "สมัครแพ็กเกจ",
    },
    employerSignupOnly: {
        pricePrefix: "เพียง",
        priceSuffix: "/ ปี",
        noSubscription: "ไม่จำเป็นต้องสมัครสมาชิก !",
        unlock: "ปลดล็อกคุณสมบัติพิเศษ",
        features1: [
            "ค้นหาได้: ข้อมูลของคุณจะปรากฏในผลการค้นหาของนายจ้าง",
            "อัปเดตที่ตั้ง: ให้ข้อมูลที่ตั้งล่าสุดเพื่อดึงดูดนายจ้างในพื้นที่",
            "สถิติโปรไฟล์: ดูจำนวนผู้ที่เข้าชมโปรไฟล์ของคุณ",
            "การแจ้งเตือน: รับการแจ้งเตือนเมื่อมีคนติดต่อคุณและดูตำแหน่งของพวกเขา"
        ],
        profileManagement: "การจัดการโปรไฟล์",
        features2: [
            "เพิ่มรูปโปรไฟล์",
            "อัปโหลดเรซูเม่",
            "ดูรายละเอียดนายจ้าง",
            "เขียนแนะนำตัวเอง",
            "ควบคุมการแสดงผลของโปรไฟล์"
        ],
        andMore: "และอีกมากมาย!",
        payBy: "ชำระเงินผ่าน",
        qrCode: "QR Code",
        card: "บัตรเครดิตหรือเดบิต"
    },
    terms: {
        title: 'ข้อกำหนดในการให้บริการ (นายจ้าง)',
        intro: 'ยินดีต้อนรับสู่ Search in Thailand Jobs Board โดยการสมัครบัญชีและใช้บริการในฐานะนายจ้าง คุณตกลงที่จะปฏิบัติตามข้อกำหนดต่อไปนี้:',
        footer: 'โดยการสร้างบัญชีนายจ้าง คุณตกลงตามข้อกำหนดเหล่านี้และยืนยันว่าคุณได้อ่าน ทำความเข้าใจ และยอมรับคำปฏิเสธความรับผิดทางกฎหมายนี้แล้ว',
        sections: [
            {
                heading: '1. คุณสมบัติทางกฎหมาย',
                text: 'คุณยืนยันว่าคุณมีสิทธิ์ตามกฎหมายในการจ้างงานในประเทศไทยตามกฎหมายที่มีผลบังคับใช้ในปี 2567...'
            },
            {
                heading: '2. การตรวจสอบสถานะทางกฎหมาย',
                text: 'คุณต้องรับผิดชอบแต่เพียงผู้เดียวในการตรวจสอบว่าคุณมีสิทธิ์ในการจ้างงานในประเทศไทย...'
            },
            {
                heading: '3. ข้อยกเว้นความรับผิดชอบ',
                text: 'SearchinThailand.com และ Talent Partners Co., Ltd. จะไม่รับผิดชอบต่อการตรวจสอบสถานะทางกฎหมายของคุณ...'
            },
            {
                heading: '4. การปฏิบัติตามกฎหมายไทย',
                text: 'คุณตกลงที่จะปฏิบัติตามกฎหมายและระเบียบข้อบังคับของประเทศไทยอย่างเคร่งครัด...'
            },
            {
                heading: '5. กิจกรรมที่ห้าม',
                list: [
                    'ใช้ชื่อ รูปภาพ หรือข้อมูลส่วนตัวของผู้อื่นโดยไม่ได้รับอนุญาต.',
                    'ละเมิดมาตรา 112 หรือกฎหมายหมิ่นพระบรมเดชานุภาพ.',
                    'หลอกลวงหรือแอบอ้าง.',
                    'เลือกปฏิบัติต่อผู้สมัครงาน.',
                    'ละเมิดลิขสิทธิ์.',
                    'ล่วงละเมิดหรือกลั่นแกล้ง.',
                    'เก็บข้อมูลโดยไม่ได้รับความยินยอม.',
                    'ส่งเสริมธุรกิจแชร์ลูกโซ่.',
                    'ติดต่อโดยมีเจตนาอื่นที่ไม่ใช่งาน.',
                    'ลงประกาศงานปลอม.',
                    'เผยแพร่ไวรัสหรือมัลแวร์.',
                    'ดึงข้อมูลไปใช้โดยไม่ได้รับอนุญาต.',
                    'จัดการเรตติ้งผู้ใช้โดยไม่เป็นธรรม.'
                ]
            },
            {
                heading: '6. การสื่อสารและพฤติกรรม',
                list: [
                    'ติดต่อเฉพาะเรื่องงานเท่านั้น.',
                    'ห้ามคุกคามหรือแสดงพฤติกรรมไม่เหมาะสม.',
                    'ให้คะแนนอย่างซื่อสัตย์และยุติธรรม.'
                ]
            },
            {
                heading: '7. การรายงานและความรับผิดชอบ',
                text: 'นายจ้างและผู้สมัครสามารถรายงานการละเมิดได้ แพลตฟอร์มจะตรวจสอบและดำเนินการตามความเหมาะสม.'
            },
            {
                heading: '8. การยกเลิกบัญชี',
                text: 'หากไม่ปฏิบัติตามข้อกำหนด บัญชีของคุณอาจถูกยกเลิกทันทีและไม่สามารถใช้งานได้อีก.'
            },
            {
                heading: '9. การคุ้มครองข้อมูล',
                text: 'เราจะปกป้องข้อมูลของคุณ แต่คุณต้องรับผิดชอบต่อข้อมูลการเข้าสู่ระบบของคุณด้วย.'
            },
            {
                heading: '10. ข้อจำกัดความรับผิด',
                text: 'เราไม่รับผิดชอบต่อความเสียหายที่เกิดจากการใช้งานแพลตฟอร์มของคุณ.'
            },
            {
                heading: '11. การเปลี่ยนแปลงข้อกำหนด',
                text: 'เราอาจเปลี่ยนแปลงข้อกำหนดโดยไม่ต้องแจ้งให้ทราบล่วงหน้า การใช้งานต่อแสดงว่าคุณยอมรับ.'
            }
        ]
    },
    jobseekerProfileModal: {
        tooltipNotInterestedLogin: "กรุณาเข้าสู่ระบบเพื่อระบุว่าไม่สนใจ",
        tooltipBookmarkLogin: "กรุณาเข้าสู่ระบบเพื่อบันทึก",
        notInterested: "ไม่สนใจ",
        removeNotInterested: "ลบออกจากรายการไม่สนใจ",
        bookmark: "บันทึก",
        removeBookmark: "ลบออกจากรายการบันทึก",
        jobCategory: "ประเภทงาน:",
        availability: "ความพร้อมในการทำงาน:",
        salary: "เงินเดือนที่ต้องการ:",
        negotiable: "สามารถต่อรองได้",
        languages: "ภาษาที่พูดได้:",
        aboutMe: "เกี่ยวกับฉัน:",
        call: "โทร",
        sendMessage: "ส่งข้อความ",
        lineId: "ไลน์ไอดี",
        viewCV: "ดูประวัติส่วนตัวของฉัน",
        memberSince: "เป็นสมาชิกตั้งแต่"
    },
    jobSeekerSignup: {
        locationVerification: {
            title: "ยืนยันตำแหน่งที่ตั้ง",
            notInThailand: "คุณไม่ได้อยู่ในประเทศไทย",
            back: "ย้อนกลับ",
        },
        step0: {
            heading: "สมัครใช้งานฟรีและเริ่มต้นอาชีพของคุณ",
            subheading: "เชื่อมต่อกับนายจ้างในประเทศไทยและต่างประเทศ",
            findJobsTitle: "หางานได้อย่างรวดเร็ว",
            findJobsDesc: "ค้นหางานที่ตรงกับทักษะและเป้าหมายของคุณ และสมัครได้โดยตรงจากโปรไฟล์ของคุณ",
            showcaseTitle: "แสดงศักยภาพของคุณ",
            showcaseDesc: "สร้างโปรไฟล์ที่สามารถค้นหาได้ เพื่อให้นายจ้างเห็นประสบการณ์ ทักษะ และเรซูเม่ของคุณ",
            instantConnectTitle: "เชื่อมต่อนายจ้างได้ทันที",
            instantConnectDesc: "ติดต่อกับนายจ้างทั้งในประเทศไทยและทั่วโลก และเปิดรับโอกาสที่เข้ามา",
            personalizedTitle: "ระบบจับคู่งานเฉพาะตัว",
            personalizedDesc: "ปลดล็อกคำแนะนำงานที่ตรงกับจุดแข็งและความสนใจของคุณ",
            getStarted: "เริ่มต้น"
        },
        step1: {
            heading: "สมัครใช้งานฟรีและเริ่มต้นอาชีพของคุณ",
            subheading: "เชื่อมต่อกับนายจ้างในประเทศไทยและต่างประเทศ",
            alreadyHaveAccount: "มีบัญชีอยู่แล้ว?",
            login: "เข้าสู่ระบบ",
            firstName: "ชื่อ",
            lastName: "นามสกุล",
            firstNamePlaceholder: "กรอกชื่อของคุณ",
            lastNamePlaceholder: "กรอกนามสกุลของคุณ",
            email: "อีเมล",
            emailPlaceholder: "กรอกอีเมลของคุณ",
            confirmEmail: "ยืนยันอีเมล",
            confirmEmailPlaceholder: "กรอกอีเมลอีกครั้ง",
            termsOfService: "ข้าพเจ้ายอมรับ",
            termsLink: "ข้อกำหนดการให้บริการ",
            legalAge: "ข้าพเจ้ายืนยันว่ามีอายุอย่างน้อย 18 ปี และสามารถทำงานในประเทศไทยได้ตามกฎหมาย",
            sendCode: "ส่งรหัสยืนยันทางอีเมล",
            enterCode: "กรอกรหัสยืนยันอีเมล",
            codePlaceholder: "รหัสยืนยัน"
        },
        step2: {
            heading: "สร้างรหัสผ่าน",
            description: "กรุณาสร้างรหัสผ่านสำหรับบัญชีของคุณ",
            password: "รหัสผ่าน",
            passwordPlaceholder: "กรอกรหัสผ่าน",
            confirmPassword: "ยืนยันรหัสผ่าน",
            confirmPasswordPlaceholder: "ยืนยันรหัสผ่านอีกครั้ง"
        },
        step3: {
            preferencesTitle: "ความต้องการในการทำงาน",
            searchJobPosition: "ค้นหาตำแหน่งงาน",
            searchJobPositionPlaceholder: "เริ่มพิมพ์เพื่อตำแหน่งงานที่คุณต้องการ",
            desiredIndustry: "อุตสาหกรรมที่ต้องการ",
            desiredIndustryPlaceholder: "ค้นหาหมวดหมู่งาน",
            specialization: "ความเชี่ยวชาญ",
            specializationPlaceholder: "เลือกประเภทตำแหน่งงาน",
            position: "ตำแหน่ง",
            positionPlaceholder: "ประเภทตำแหน่ง",
            employmentType: "ประเภทการจ้างงาน",
            selectEmploymentType: "ระบุประเภทของงานที่คุณต้องการ",
            availability: "ความพร้อมในการทำงาน",
            daysAvailable: "วันที่สามารถทำงานได้",
            selectDaysAvailable: "เลือกวันที่สามารถทำงานได้",
            selectCustomDays: "เลือกวันด้วยตนเอง",
            payments: "ค่าตอบแทน",
            salaryExpectations: "เงินเดือนที่คาดหวัง",
            selectPaymentType: "เลือกประเภทเงินเดือนที่ต้องการ",
            enterRange: "ใส่ช่วงเงินเดือน"
        },
        step4: {
            title: "ยืนยันหมายเลขโทรศัพท์",
            subtitle: "ขอบคุณ {name} กรุณาใช้หมายเลขโทรศัพท์ในประเทศไทยเท่านั้น",
            sendCodeButton: "ส่งรหัสยืนยัน",
            enterCodeLabel: "กรอกรหัสยืนยัน",
            phonePlaceholder: "กรอกหมายเลขโทรศัพท์ของคุณ"
        },
        step5: {
            title: 'ช่องทางการติดต่อที่คุณต้องการ',
            subtitle: 'คุณต้องการให้นายจ้างติดต่อคุณผ่านช่องทางใด?',
            selectInstruction: 'เลือกตัวเลือกที่คุณต้องการด้านล่าง:',
            emailLabel: 'อีเมล',
            emailNote: 'นายจ้างจะสามารถติดต่อคุณผ่านระบบข้อความภายในเท่านั้น ที่อยู่อีเมลของคุณจะไม่ถูกเปิดเผย',
            phoneLabel: 'เบอร์โทร',
            phoneNote: 'เบอร์โทรของคุณจะแสดงเฉพาะให้นายจ้างที่ผ่านการยืนยันเท่านั้น',
        },
        step6: {
            title: 'เสร็จสิ้นการลงทะเบียนของคุณ',
            subtitle1: 'สมัครงานได้ 3 ตำแหน่งต่อวันฟรี',
            subtitle2: 'สมัครสมาชิกฟรีและปลดล็อกฟีเจอร์ทั้งหมดของเรา',
            signupNow: 'สมัครสมาชิกตอนนี้',
            unlockFeatures: 'ปลดล็อกฟีเจอร์พรีเมียม',
            feature1: { title: 'ค้นหาได้:', desc: 'ข้อมูลของคุณจะปรากฏในการค้นหาของนายจ้าง' },
            feature2: { title: 'อัปเดตตำแหน่งที่ตั้ง:', desc: 'อัปเดตตำแหน่งของคุณเพื่อดึงดูดนายจ้างใกล้คุณ' },
            feature3: { title: 'สถิติโปรไฟล์:', desc: 'ดูจำนวนผู้ที่เข้าชมโปรไฟล์ของคุณ' },
            feature4: { title: 'การแจ้งเตือน:', desc: 'รับแจ้งเตือนเมื่อมีนายจ้างติดต่อคุณ และดูตำแหน่งของพวกเขา' },
            profileManagement: 'การจัดการโปรไฟล์',
            pm1: 'เพิ่มรูปโปรไฟล์',
            pm2: 'อัปโหลดเรซูเม่ของคุณ',
            pm3: 'ดูรายละเอียดนายจ้าง',
            pm4: 'เขียนแนะนำตัวเอง',
            pm5: 'ควบคุมการมองเห็นของโปรไฟล์',
            andMore: 'และอีกมากมาย!',
            signUp: 'สมัครสมาชิก',
            forFree: 'ฟรี'
        },
        previous: "← ก่อนหน้า",
        next: "ถัดไป →",
        createAccount: 'สร้างบัญชี',
    },
    jobSearch: {
        placeholder: 'ค้นหางานและผู้สมัครที่ดีที่สุดในประเทศไทย…',
        filterOptions: 'ตัวเลือกการกรอง',
        loginWarning: 'กรุณาสร้างบัญชีหรือเข้าสู่ระบบเพื่อค้นหางานหรือนายจ้าง',
        enterSearchTerm: 'กรุณากรอกคำค้นหา',
        selectIndustryFirst: "คุณต้องเลือก ‘อุตสาหกรรม’ ก่อนจึงจะค้นหาได้",
        search: "ค้นหา",
        industry: "อุตสาหกรรม",
        selectIndustry: "เลือกอุตสาหกรรม",
        specialization: "ความเชี่ยวชาญ",
        selectSpecialization: "ความเชี่ยวชาญ",
        optional: "(ไม่จำเป็น)",
        position: "ตำแหน่ง",
        positionTypes: "ประเภทตำแหน่ง",
        province: "จังหวัด",
        language: "ภาษา",
        simpleSearch: "ค้นหาแบบง่าย",
        advancedSearch: "ค้นหาแบบละเอียด",
        clearFields: "ล้างข้อมูล",
        district: "อำเภอ",
        selectDistrict: "เลือกอำเภอ (ไม่จำเป็น)",
        subdistrict: "ตำบล",
        selectSubdistrict: "เลือกตำบล",
        salaryRequirement: "เงินเดือนที่ต้องการ",
        salaryRequirementPlaceholder: "เงินเดือนที่ต้องการ",
        gender: "เพศ",
        selectGender: "เลือกเพศ",
        availability: "ความพร้อมในการทำงาน",
        industryRequired: "คุณต้องเลือก 'อุตสาหกรรม' ก่อนจึงจะค้นหาได้",
    },
    aboutUs: {
        heart: 'หัวใจของงานของเรา:',
        mission: 'ภารกิจที่เรียบง่ายแต่น่าทึ่ง — เชื่อมโยงผู้คน ธุรกิจ และชุมชนทั่วประเทศไทย ด้วยโครงสร้างพื้นฐานดิจิทัลที่ชาญฉลาดและเข้าถึงได้ ซึ่งช่วยเสริมโอกาสในท้องถิ่นและขยายไปสู่ระดับสากล',
        believe: 'เราเชื่อว่า:',
        vision: 'โอกาสควรหาได้ง่ายและสามารถใช้ได้จริง — ไม่ว่าคุณจะเป็นผู้หางานที่กำลังมองหาตำแหน่งที่เหมาะสม ธุรกิจที่ต้องการบุคลากร หรือผู้ประกอบการที่พร้อมจะเติบโต โดยการจัดระเบียบทรัพยากรของประเทศไทยและเพิ่มการเข้าถึงโอกาสทั้งในประเทศและระดับโลก เรากำลังช่วยสร้างเศรษฐกิจที่แข็งแกร่งและเชื่อมโยงมากยิ่งขึ้น',
        cta: 'ไปกันเลย!'
    },
    investors: {
        title: "ลงทุนในอนาคตของประเทศไทย",
        desc1: "SearchinThailand กำลังสร้างระบบค้นหาและการจ้างงานแห่งแรกของประเทศ — เพื่อเชื่อมโยงผู้คน ธุรกิจ และโอกาส ทั้งในประเทศและระดับนานาชาติ",
        desc2: "ในขณะที่เรากำลังเตรียมเปิดตัว เราเปิดรับพันธมิตรเชิงกลยุทธ์และโอกาสในการลงทุนที่สอดคล้องกับภารกิจของเราในการเสริมสร้างเศรษฐกิจและโครงสร้างพื้นฐานดิจิทัลของประเทศไทย",
        desc3: "หากคุณสนใจและต้องการทราบข้อมูลเพิ่มเติม กรุณาส่งข้อความถึงเรา เรายินดีที่จะหารือเกี่ยวกับวิธีที่คุณสามารถเข้าร่วมการเดินทางนี้",
        form: {
            name: "ชื่อของคุณ",
            email: "อีเมลของคุณ",
            message: "ข้อความของคุณ",
            send: "ส่งข้อความ"
        }
    },
    privacy: {
        title: "นโยบายความเป็นส่วนตัว",
        introTitle: "บทนำ",
        introText: "ยินดีต้อนรับสู่ SearchinThailand.com เรามุ่งมั่นในการเคารพความเป็นส่วนตัวของคุณและปกป้องข้อมูลส่วนบุคคลของคุณด้วยแนวทาง 'ความเป็นส่วนตัวมาก่อน' นโยบายของเราปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) ของประเทศไทย",

        glanceTitle: "สรุปโดยย่อ",
        glance: {
            collection: "การเก็บรวบรวม: รายละเอียดส่วนบุคคลพื้นฐาน คำค้นหา สถานที่ อุปกรณ์ และสถิติการใช้งาน.",
            method: "วิธีการ: ข้อมูลถูกรวบรวมผ่านการกรอกโดยตรงและคุกกี้.",
            use: "การใช้: ปรับปรุงบริการ ความเป็นส่วนตัว และความปลอดภัย.",
            sharing: "การแบ่งปัน: เฉพาะกรณีที่กฎหมายกำหนด เราไม่ขายข้อมูลของคุณ.",
            protection: "การป้องกัน: การเข้ารหัส การควบคุมการเข้าถึง และการตรวจสอบความปลอดภัย.",
            rights: "สิทธิ์: จัดการข้อมูลของคุณได้โดยตรงผ่านบัญชีของคุณ."
        },

        infoCollectTitle: "ข้อมูลที่เรารวบรวม",
        infoCollectText: "เรารวบรวมคำค้นหาแบบไม่ระบุตัวตน ข้อมูลส่วนตัวเพื่อจัดการบัญชี รายละเอียดอุปกรณ์เพื่อการปรับปรุง และข้อมูลการใช้งานเพื่อพัฒนาประสบการณ์ของผู้ใช้.",

        useInfoTitle: "การใช้ข้อมูลของคุณ",
        useInfoText: "เรานำข้อมูลของคุณมาใช้เพื่อปรับแต่งและปรับปรุงประสบการณ์ของคุณ พัฒนาฟีเจอร์ใหม่ และรักษาความปลอดภัย.",

        shareProtectTitle: "การแบ่งปันและการป้องกันข้อมูล",
        shareProtectText: "เราไม่ขายข้อมูลของคุณ ข้อมูลจะถูกแบ่งปันเฉพาะเมื่อมีข้อกำหนดทางกฎหมายเท่านั้น และจะได้รับการปกป้องด้วยการเข้ารหัส การไม่ระบุตัวตน การควบคุมการเข้าถึง และการตรวจสอบเป็นประจำ.",

        rightsTitle: "สิทธิ์ของคุณ",
        rights: {
            access: "การเข้าถึงและการพกพา:",
            accessText: "ดาวน์โหลดข้อมูลของคุณในรูปแบบที่สามารถอ่านได้.",
            rectify: "การแก้ไข:",
            rectifyText: "แก้ไขข้อมูลที่ไม่ถูกต้องผ่านบัญชีของคุณ.",
            erase: "การลบ:",
            eraseText: "ลบบัญชีและข้อมูลที่เกี่ยวข้อง.",
            restrict: "การจำกัดและการคัดค้าน:",
            restrictText: "จำกัดวิธีการที่เราประมวลผลข้อมูลของคุณ.",
            automated: "การตัดสินใจโดยอัตโนมัติ:",
            automatedText: "ไม่มีการตัดสินใจที่สำคัญที่กระทำโดยอัตโนมัติเท่านั้น.",
        },

        retentionTitle: "การเก็บรักษาข้อมูล",
        retentionText: "ข้อมูลบัญชีจะถูกเก็บไว้ตราบเท่าที่บัญชียังเปิดใช้งาน ข้อมูลการค้นหาและการใช้งานแบบไม่ระบุตัวตนอาจถูกเก็บไว้ไม่มีกำหนดเพื่อการพัฒนา ข้อมูลจากฝ่ายสนับสนุนจะเก็บไว้เท่าที่จำเป็น.",

        transferTitle: "การถ่ายโอนข้อมูลระหว่างประเทศ",
        transferText: "ข้อมูลของคุณอาจถูกจัดเก็บในเซิร์ฟเวอร์ในสหรัฐอเมริกาซึ่งได้รับการปกป้องตามมาตรฐาน PDPA ผ่านข้อตกลงทางกฎหมายที่เข้มงวด.",

        breachTitle: "การแจ้งเหตุข้อมูลรั่วไหล",
        breachText: "หากเกิดเหตุข้อมูลรั่วไหล เราจะประเมิน ควบคุม แจ้งผู้ที่ได้รับผลกระทบ และบันทึกเหตุการณ์เพื่อความรับผิดชอบและการปรับปรุงในอนาคต.",

        legalTitle: "พื้นฐานทางกฎหมายสำหรับการประมวลผลข้อมูล",
        legalIntro: "เราประมวลผลข้อมูลของคุณตาม:",
        legal: {
            consent: "ความยินยอมสำหรับบริการเสริม เช่น การสื่อสารทางการตลาด.",
            contract: "การดำเนินการตามสัญญาสำหรับการให้บริการ.",
            obligation: "ข้อผูกพันทางกฎหมายเพื่อการปฏิบัติตามกฎหมาย.",
            interests: "ผลประโยชน์โดยชอบธรรม เช่น การปรับปรุงบริการและการป้องกันการฉ้อโกง."
        },

        updateTitle: "การปรับปรุงนโยบายนี้",
        updateText: "เราจะแจ้งให้คุณทราบหากมีการเปลี่ยนแปลงนโยบายนี้ผ่านเว็บไซต์ อีเมล หรือแจ้งเตือนในบัญชี.",

        contactTitle: "ติดต่อเรา",
        contactText: "หากคุณมีคำถามหรือต้องการใช้สิทธิ์ความเป็นส่วนตัว โปรดติดต่อเราที่:"
    },
    modalLanguageLevel: {
        cancel: 'ยกเลิก',
    },
    toast: {
        login_required_employer: `กรุณาเข้าสู่ระบบในฐานะ 'บัญชีนายจ้าง' เพื่อใช้งานฟีเจอร์นี้ <br>(คุณสามารถคลิกที่นี่เพื่อเข้าสู่ระบบ)`,
        login_required_employee: `กรุณาเข้าสู่ระบบในฐานะ 'บัญชีลูกจ้าง' เพื่อใช้งานฟีเจอร์นี้ <br>(คุณสามารถคลิกที่นี่เพื่อเข้าสู่ระบบ)`,
        language_limit: 'คุณสามารถเลือกได้สูงสุด 3 ภาษา',
    },
    support: {
        title: "ช่วยเหลือ & สนับสนุน",
        reportIssue: "ข้อเสนอแนะและการสนับสนุน",
        systemNotifications: "การแจ้งเตือนระบบ",
        securityAlerts: "ความปลอดภัย & การแจ้งเตือน",
        knowledgeBase: "ฐานความรู้ / คำถามที่พบบ่อย",
    },
    notifications: {
        system: 'การแจ้งเตือนระบบ',
        security: 'ความปลอดภัยและการแจ้งเตือน',
        default: 'การแจ้งเตือน',
        none: 'ไม่มีการแจ้งเตือน',
        close: 'ปิด',
    },
    chat: {
        noMessages: "ยังไม่มีข้อความ",
        deleteMessage: "ลบข้อความ",
        noChats: "ไม่พบแชท ลองรีเฟรชหรือลองเริ่มการสนทนาใหม่",
        deleteConversation: "ลบการสนทนา",
        blockUser: "บล็อกผู้ใช้",
        bookmarkUser: "บันทึกผู้ใช้",
        edited: "แก้ไขแล้ว",
        edit: "แก้ไข",
        delete: "ลบ",
        editPlaceholder: "แก้ไขข้อความของคุณ...",
        messagePlaceholder: "พิมพ์ข้อความ...",
        cancel: "ยกเลิก",
        deleteNotifTitle: "ลบการแจ้งเตือน?",
        deleteNotifText: "", // or "คุณแน่ใจหรือไม่ว่าต้องการลบการแจ้งเตือนนี้?"
        deleteConversationTitle: "ลบการสนทนานี้หรือไม่?",
        deleteConversationText: "", // or "ไม่สามารถกู้คืนการกระทำนี้ได้"
        confirmDelete: "ลบ",
        blockUserTitle: "บล็อกผู้ใช้นี้หรือไม่?",
        blockUserText: "", // or "คุณจะไม่ได้รับข้อความจากผู้ใช้นี้อีกต่อไป"
        deleteMessageTitle: "ลบข้อความนี้หรือไม่?",
        deleteMessageText: "", // or "การดำเนินการนี้ไม่สามารถย้อนกลับได้"
        block: "บล็อก",
        editMessageTitle: "แก้ไขข้อความของคุณ",
        save: "บันทึก",
    },
    loading: "กำลังโหลด..."
}
